/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ObjectObjectConfiguration as __Configuration } from '../object-object-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
class GalleryService extends __BaseService {
  static readonly getGalleryListPath = '/gallery';
  static readonly getGalleryDetailsPath = '/gallery/{id}';
  static readonly updateSpaceInfoCountPath = '/media/spaceinfo/count/{id}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Get List of Gallery.
   * @param params The `GalleryService.GetGalleryListParams` containing the following parameters:
   *
   * - `paginate`: Limit value for pagination.
   *
   * - `page`: Limit value for gallery list.
   *
   * - `lang`: Language short code.
   *
   * - `keywords`: Keywords for filter.
   *
   * - `category`: Category value for filter.
   */
  getGalleryListResponse(params: GalleryService.GetGalleryListParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.paginate != null) __params = __params.set('paginate', params.paginate.toString());
    if (params.page != null) __params = __params.set('page', params.page.toString());
    if (params.lang != null) __params = __params.set('lang', params.lang.toString());
    if (params.keywords != null) __params = __params.set('keywords', params.keywords.toString());
    if (params.category != null) __params = __params.set('category', params.category.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/gallery`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Get List of Gallery.
   * @param params The `GalleryService.GetGalleryListParams` containing the following parameters:
   *
   * - `paginate`: Limit value for pagination.
   *
   * - `page`: Limit value for gallery list.
   *
   * - `lang`: Language short code.
   *
   * - `keywords`: Keywords for filter.
   *
   * - `category`: Category value for filter.
   */
  getGalleryList(params: GalleryService.GetGalleryListParams): __Observable<null> {
    return this.getGalleryListResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Get Galley List with slug.
   * @param id Uuid value.
   */
  getGalleryDetailsResponse(id: string): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/gallery/${encodeURIComponent(String(id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Get Galley List with slug.
   * @param id Uuid value.
   */
  getGalleryDetails(id: string): __Observable<null> {
    return this.getGalleryDetailsResponse(id).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Update click count of space infos.
   * @param id Uuid value.
   */
  updateSpaceInfoCountResponse(id: string): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/media/spaceinfo/count/${encodeURIComponent(String(id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Update click count of space infos.
   * @param id Uuid value.
   */
  updateSpaceInfoCount(id: string): __Observable<null> {
    return this.updateSpaceInfoCountResponse(id).pipe(
      __map(_r => _r.body as null)
    );
  }
}

module GalleryService {

  /**
   * Parameters for getGalleryList
   */
  export interface GetGalleryListParams {

    /**
     * Limit value for pagination.
     */
    paginate: number;

    /**
     * Limit value for gallery list.
     */
    page: number;

    /**
     * Language short code.
     */
    lang?: string;

    /**
     * Keywords for filter.
     */
    keywords?: string;

    /**
     * Category value for filter.
     */
    category?: string;
  }
}

export { GalleryService }
